/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { message, Modal, Select, Form } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Style from './style';

import { displayMessage } from '../../helpers/Messages';
import { actions as sclActions } from '../../store/reducers/scl';
import { actions as lirActions } from '../../store/reducers/lir';
import { actions as stkActions } from '../../store/reducers/stakeholder';
import { actions as eventActions } from '../../store/reducers/events';
import { actions as documentActions } from '../../store/reducers/documents';
import { actions as projectActions } from '../../store/reducers/project';
import { actions as spActions } from '../../store/reducers/sp';
import { actions as imActions } from '../../store/reducers/im';
import { actions as sciActions } from '../../store/reducers/sci';
import { actions as bpeActions } from '../../store/reducers/bpe';
import { actions as gmActions } from '../../store/reducers/gm';
import { Sections } from './sections';
import moment from 'moment';
import _ from 'lodash';
import i18next from "i18next"
import { EditForm } from './form';
import { MessageTypes } from '../../helpers/Messages';
import { mapFormGroup } from './helper';
import { Template } from './templates';
import { canViewFeatureAction } from '../../constants/roles';
import { isClient } from '../../routes/ModuleRouter';
import NotFound from '../../components/NotFound';
import Loading from '../../components/Loading';
import { PROJECTS } from '../../helpers/CanAccess';
import { SelectContext } from '../../context/Select';
import { propHasValue } from "../../components/DynamicFormNew/helper";
import { getPopupContainer } from '../../helpers/popUp';
import { NOTIFICATION_MODE, onBeforeUnload, useForms } from '../../context/Forms';
import { checkPermission } from '../../permissions/usePermissions';
import { Header, ModalHeader } from 'datastake-daf/dist/components';
import { analysisNamespaces } from '../View';
import { renderBreadCrumbs } from '../../helpers/breadCrumbs';
import EditTIF from '../EditTIF';

const supportedNamespaces = {
  cadd: [
    'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm',
  ],
  pme: [
    'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'document', 'lir', 'incidents', 'corrective-actions', 'kyc',
  ],
  tif: [
    'mine-operators', 'stakeholder', 'scp', 'location', 'scl', 'village', 'project', 'event', 'incidents', 'corrective-actions', 'document', 'lir', 'kyc', 'sp', 'im', 'sci', 'bpe', 'gm',
  ]
}

const isArrayOfObjects = (arr) => Array.isArray(arr) && arr
  .map(i => typeof i === 'object')
  .every(i => i);

export const hasNotChanged = (old, newData) => {
  return _.union(Object.keys(old), Object.keys(newData))
    .map(key => {
      switch (typeof newData[key]) {
        case undefined:
          return true;
        case 'object':
          try {
            if (moment.isMoment(newData[key])) {
              if (typeof newData[key].format === 'function') {
                return old[key] === newData[key].format('YYYY-MM-DD');
              }
              return old[key] === moment(newData[key]._d).format('YYYY-MM-DD');
            } else if (isArrayOfObjects(newData[key])) {
              return newData[key].length === (old[key] || []).length && newData[key].map((oKey, i) => hasNotChanged((old[key] || [])[i] || {}, oKey || {})).every(i => i);
            }
          } catch (e) {
            // console.log(e, data[key], key);
          }
          return _.isEqual(old[key], newData[key]);
        case 'number':
        case 'string':
        case 'boolean':
          return old[key] === newData[key];
        default:
          return false;
      }
    }).every(key => key);
}

const actions = {
  ...sclActions,
  ...lirActions,
  ...stkActions,
  ...eventActions,
  ...documentActions,
  ...projectActions,
  ...spActions,
  ...imActions,
  ...sciActions,
  ...bpeActions,
  ...gmActions,
};

const Edit = ({
  actions = [],

  // reducer
  authentication: { user, selectedProject },
  stakeholder: { data: stakeholderData },
  scl: { data: sclData },
  events: { data: eventData },
  documents: { data: documentData },
  lir: { data: lirData },
  project: { data: projectData },
  sp: { data: spData },
  im: { data: imData },
  sci: { data: sciData },
  bpe: { data: bpeData },
  gm: { data: gmData },

  // data get
  SCLDataGet,
  stakeholderDataGet,
  eventsDataGet,
  documentsDataGet,
  ProjectDataGet,
  lirDataGet,
  spDataGet,
  imDataGet,
  sciDataGet,
  bpeDataGet,
  gmDataGet,

  //submit action
  stakeholderSubmit,
  SCLSubmit,
  SCLRiskSubmit,
  lirSubmit,
  eventsSubmit,
  documentsSubmit,
  ProjectSubmit,
  spSubmit,
  imSubmit,
  sciSubmit,
  bpeSubmit,
  gmSubmit,

  //remove
  ProjectRemove,
  eventsRemove,
  sclRemove,
  stakeholderRemove,
  lirRemove,
  mode = 'app',

  //other keys
  excludedKeys = [],
  disabledInputs = [],
  checkDuplicates = true,
}) => {
  const [MainForm] = Form.useForm();
  const goTo = useNavigate();
  const allData = { stakeholderData, sclData, eventData, documentData, lirData, projectData, spData, imData, sciData, bpeData, gmData };
  const { setNotificationMode, notificationMode, changeNotificationState } = useForms();
  const params = useParams();
  const [namespace, setNamespace] = useState(params.namespace);
  const [id, setId] = useState(params.id);
  const [group, setGroup] = useState(params.group);
  const [subsection, setSubSection] = useState(params.subsection);
  const [subgroup, setSubGroup] = useState(params.subgroup);
  const [formid, setFormId] = useState(params.formid);
  const {
    clear,
  } = useContext(SelectContext);

  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const [form, setForm] = useState([]);
  const [formPath, setFormPath] = useState([]);
  const [formConfig, setFormConfig] = useState({});
  const [selectedForm, setSelectedForm] = useState({});
  const [language, setLanguage] = useState(user.language);
  const [data, setData] = useState({});
  const [editValues, setEditValues] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [changedPath, setChangedPath] = useState([]);
  const [originalData, setOriginalData] = useState({});
  const [hasSubSections] = useState([]);
  const [titleDetails, setTitleDetails] = useState([]);
  const [linkingForms, setLinkingForms] = useState({});
  const [deletionVisible, setDeletionVisible] = useState(false);
  const [deletionReason, setDeletionReason] = useState(null);
  const [, module] = mode === 'proxy' ?
    pathname.split(/\/proxy\/(pme|cadd|tif)\/edit/)
    : pathname.split(/\/app\/(pme|cadd|tif)\/edit/);
  const isSupported = (supportedNamespaces[module] && supportedNamespaces[module].includes(namespace)) && selectedProject === PROJECTS.myData;
  const [loading, setLoading] = useState(isSupported);
  const queryParam = new URLSearchParams(search);
  let sourceId = queryParam.get('sourceId') || undefined;
  if (!sourceId && localStorage.getItem('source')) {
    sourceId = localStorage.getItem('source');
  }

  const match = useMemo(() => ({
    params,
    path: pathname,
  }), [params, pathname]);

  const dataKey = {
    stakeholder: 'stakeholderData',
    scp: 'stakeholderData',
    'mine-operators': 'stakeholderData',
    kyc: 'stakeholderData',
    location: 'sclData',
    scl: 'sclData',
    village: 'sclData',
    event: 'eventData',
    incidents: 'eventData',
    'corrective-actions': 'eventData',
    document: 'documentData',
    lir: 'lirData',
    project: 'projectData',
    sp: 'spData',
    im: 'imData',
    sci: 'sciData',
    bpe: 'bpeData',
    gm: 'gmData',
  };

  const hasKey = (obj, key) => Object.keys(obj).includes(key);

  const namespaceGet = {
    stakeholder: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      sourceId,
    }),
    scp: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      sourceId,
    }),
    'mine-operators': () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      stakeholderId: id,
      sourceId,
    }),
    kyc: () => stakeholderDataGet({
      namespace: 'Stakeholder',
      module,
      view: namespace.toLowerCase(),
      sourceId,
    }),
    location: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      sourceId,
    }),
    scl: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      sourceId,
    }),
    village: () => SCLDataGet({
      namespace: 'SCL',
      module,
      view: 'scoping',
      sclId: id,
      sourceId,
    }),
    event: () => eventsDataGet({
      namespace: 'Events',
      module,
      view: 'scoping',
      datastakeId: id,
      sourceId,
    }),
    incidents: () => eventsDataGet({
      namespace: 'Events',
      module,
      view: 'scoping',
      datastakeId: id,
      sourceId,
    }),
    'corrective-actions': () => eventsDataGet({
      namespace: 'Events',
      module,
      view: 'scoping',
      datastakeId: id,
      sourceId,
    }),
    document: () => documentsDataGet({
      namespace: 'Documents',
      module,
      view: 'scoping',
      datastakeId: id,
      sourceId,
    }),
    lir: () => lirDataGet({
      namespace: 'Lir',
      module,
      view: 'scoping',
      lirId: id,
      sourceId,
    }),
    project: () => ProjectDataGet({
      namespace: 'PMEProject',
      module,
      view: 'project',
      projectId: id,
      sourceId,
    }),
    sp: () => spDataGet({
      namespace: 'SupplyChainPolicy',
      module,
      view: 'scoping',
      sourceId,
    }),
    im: () => imDataGet({
      namespace: 'IMS',
      module,
      view: 'scoping',
      sourceId,
    }),
    sci: () => sciDataGet({
      namespace: 'SCI',
      module,
      view: 'scoping',
      sourceId,
    }),
    bpe: () => bpeDataGet({
      namespace: 'BPE',
      module,
      view: 'scoping',
      sourceId,
    }),
    gm: () => gmDataGet({
      namespace: 'GM',
      module,
      view: 'scoping',
      sourceId,
    }),
  };

  const viewGet = {
    stakeholder: namespace.toLowerCase(),
    scp: namespace.toLowerCase(),
    'mine-operators': namespace.toLowerCase(),
    kyc: namespace.toLowerCase(),
    location: 'scoping',
    scl: 'scoping',
    village: 'scoping',
    event: 'scoping',
    'corrective-actions': 'scoping',
    incidents: 'scoping',
    document: 'scoping',
    lir: 'scoping',
    project: 'project',
    sp: 'scoping',
    im: 'scoping',
    sci: 'scoping',
    bpe: 'scoping',
    gm: 'scoping',
  }

  const submitCall = {
    stakeholder: stakeholderSubmit,
    scp: stakeholderSubmit,
    'mine-operators': stakeholderSubmit,
    kyc: stakeholderSubmit,
    location: SCLSubmit,
    scl: SCLSubmit,
    village: SCLSubmit,
    lir: lirSubmit,
    event: eventsSubmit,
    incidents: eventsSubmit,
    'corrective-actions': eventsSubmit,
    document: documentsSubmit,
    project: ProjectSubmit,
    risk: {
      location: SCLRiskSubmit,
      scl: SCLRiskSubmit,
      village: SCLRiskSubmit,
    },
    sp: spSubmit,
    im: imSubmit,
    sci: sciSubmit,
    bpe: bpeSubmit,
    gm: gmSubmit,
  }
  const isProjectApproved = () => {
    return data &&
      data.id &&
      user &&
      user.projects &&
      Array.isArray(user.projects) &&
      user.projects.filter(p => p.id === data.id && p.status === 'approved').length === 1 ? true : false;
  }
  const isUserData = () => {
    return data && data.authorId && (user?.company?.id === data.authorId)
  }
  const callToGetData = (force = false) => {
    if (isSupported) {
      const dKey = dataKey[namespace];
      let nKey = `${module}-${namespace}`;
      if (['location', 'scl', 'village'].includes(namespace)) {
        nKey = `${module}-scoping`;
      }
      if (
        !(
          hasKey(allData, dKey) &&
          hasKey(allData[dKey], nKey) &&
          hasKey(allData[dKey][nKey], 'data') &&
          hasKey(allData[dKey][nKey]['data'], 'datastakeId') &&
          allData[dKey][nKey]['data']['datastakeId'] === id
        ) || user.language !== language || force) {
        namespaceGet[namespace]();
        setLanguage(user.language);
      }
    }
  }
  const onStorageUpdate = (e) => {
    const { key, newValue } = e;
    if (key === `${id}-loading` && newValue) {
      setLoading(newValue);
    }
    if (key === `${id}-updated` && newValue) {
      setLoading(true);
      callToGetData(true);
    }
  };
  useEffect(() => {
    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, []);
  const canEditAction = {
    stakeholder: () => checkPermission({ permission: 'stakeholders.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    scp: () => checkPermission({ permission: 'stakeholders.SCA.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    // TO-DO add permissions
    'mine-operators': () => checkPermission({ permission: 'stakeholders.SCA.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    location: () => checkPermission({ permission: 'locations.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    scl: () => checkPermission({ permission: 'locations.mineSites.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    village: () => checkPermission({ permission: 'locations.villages.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    project: () => checkPermission({ permission: 'projects.canEdit', permissions: user?.role?.permissions }) &&
      !user?.company?.id &&
      isProjectApproved() && canViewFeatureAction({ user, module, feature: 'projects', action: 'edit' }) && (
        isClient(user) || (data && data.authorId === user?.company?.id)
      ),
    event: () => checkPermission({ permission: 'events.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    incidents: () => checkPermission({ permission: 'events.incidents.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    'corrective-actions': () => (canViewFeatureAction({ user, module, feature: 'event', action: 'edit' }) ||
      canViewFeatureAction({ user, module, feature: 'events', action: 'create' }))
      && isUserData(),
    document: () => checkPermission({ permission: 'documents.canEdit', permissions: user?.role?.permissions })
      && isUserData(),
    lir: () => checkPermission({ permission: 'stakeholders.LIR.canEdit', permissions: user?.role?.permissions })
      && data && data.authorId && (user?.company?.id === data.authorId),
    kyc: () => checkPermission({ permission: 'myOrganisation.KYC.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    sp: () => checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    im: () => checkPermission({ permission: 'myOrganisation.DDSystems.internalManagement.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    sci: () => checkPermission({ permission: 'myOrganisation.DDSystems.SCP.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    bpe: () => checkPermission({ permission: 'myOrganisation.DDSystems.supplierEngagement.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
    gm: () => checkPermission({ permission: 'myOrganisation.DDSystems.grievanceMechanism.canEdit', permissions: user?.role?.permissions }) &&
      (isUserData() || !data.authorId),
  }
  // params
  useEffect(() => {
    setNamespace(params.namespace);
    setId(params.id);
    setGroup(params.group);
    setSubSection(params.subsection);
    setSubGroup(params.subgroup);
    setFormId(params.formid);
  }, [params]);

  useEffect(() => {
    callToGetData();
  }, [id, namespace, user.language]);

  const prepareForm = (setExtra = true) => {
    if (isSupported) {
      const dKey = dataKey[namespace];
      const nKey = `${module}-${viewGet[namespace]}`;
      if (hasKey(allData, dKey) && hasKey(allData[dKey], nKey)) {
        const d = JSON.parse(JSON.stringify((allData[dKey][nKey].data || {})));
        Object.keys(d).forEach((k) => {
          if (d[k] === null) {
            d[k] = undefined;
          }
        })
        if (d.datastakeId === id || id === 'user') {
          const c = allData[dKey][nKey].config || {};
          const formG = mapFormGroup(allData[dKey][nKey].form || {}, d);
          setForm(formG);

          const formPaths = formG.filter(f => f.show && !f.excludeFromEdit).reduce((paths, item) => {
            if (item.items) {
              Object.keys(item.items).forEach(i => {
                if (item.items[i].show) {
                  paths.push(`${item.id}/${i}`);
                }
              })
            } else {
              paths.push(item.id);
            }
            return paths;
          }, []);

          setFormPath(formPaths);
          if (setExtra) {
            if ((d || {}).risk && Array.isArray(formG) && formG.find(r => r.id === 'risk')) {
              const form = formG.find(r => r.id === 'risk');
              if (form && form.options && form.template === 'risk') {
                const newData = Object.keys(d.risk).reduce((all, key) => {
                  const forms = form.options[key].forms;
                  const formsKeys = Object.keys(forms);
                  const formData = formsKeys.map(k => {
                    const foundValue = d.risk[key].find(v => v.subCategory === k);
                    return foundValue || {
                      id: k,
                      components: {},
                      config: [],
                      connectedEvents: {},
                      category: key,
                      score: 0,
                      subCategory: k,
                    };
                  });
                  all[key] = formData;
                  return all;
                }, {});
                setData({ ...d, risk: newData });
                setEditValues({ ...d });
                setOriginalData({ ...d });
                setFormConfig(c);
                setLinkingForms(allData[dKey][nKey].linkingForms);
                setLoading(false);
                return;
              }
            }
            setData({ ...d });
            setEditValues({ ...d });
            setOriginalData({ ...d });
            setFormConfig(c);
            setLinkingForms(allData[dKey][nKey].linkingForms);
            setLoading(false);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (isSupported) {
      const extraDesc = [];
      if (['location', 'scl', 'village'].includes(namespace)) {
        extraDesc.push(<span className="entity-name">
          <EnvironmentOutlined />
          {data.locationName}
        </span>)

      } else {
        extraDesc.push(<span className="entity-name">
          {data.name}
        </span>)
      }
      setTitleDetails(extraDesc)
    }
  }, [data])

  useEffect(() => {
    if (['stakeholder', 'scp', 'mine-operators', 'kyc'].includes(namespace)) {
      prepareForm();
    }
  }, [stakeholderData])

  useEffect(() => {
    if (['location', 'scl', 'village'].includes(namespace)) {
      prepareForm();
    }
  }, [sclData])

  useEffect(() => {
    if (['event', 'incidents', 'corrective-actions'].includes(namespace)) {
      prepareForm();
    }
  }, [eventData])

  useEffect(() => {
    if (['document'].includes(namespace)) {
      prepareForm();
    }
  }, [documentData])

  useEffect(() => {
    if (['lir'].includes(namespace)) {
      prepareForm();
    }
  }, [lirData])

  useEffect(() => {
    if (['project'].includes(namespace)) {
      prepareForm();
    }
  }, [projectData])

  useEffect(() => {
    if (['sp'].includes(namespace)) {
      prepareForm();
    }
  }, [spData])

  useEffect(() => {
    if (['im'].includes(namespace)) {
      prepareForm();
    }
  }, [imData])

  useEffect(() => {
    if (['sci'].includes(namespace)) {
      prepareForm();
    }
  }, [sciData])

  useEffect(() => {
    if (['bpe'].includes(namespace)) {
      prepareForm();
    }
  }, [bpeData])

  useEffect(() => {
    if (['gm'].includes(namespace)) {
      prepareForm();
    }
  }, [gmData])

  const getViewLink = () => {
    switch (namespace) {
      case 'sp':
      case 'im':
      case 'sci':
      case 'bpe':
      case 'gm':
        return `/${mode}/${module}/viewdd/${namespace}/${id}/${group}${subsection ? `/${subsection}` : ''}${subgroup ? `/${subgroup}` : ''}`
      default:
    }
    return `/${mode}/${module}/view/${namespace}/${id}/${group}${subsection ? `/${subsection}` : ''}${subgroup ? `/${subgroup}` : ''}`;
  }

  let currentpath = group;
  if (subsection) {
    currentpath += `/${subsection}`;
  }
  if (subgroup) {
    currentpath += `/${subgroup}`;
  }
  if (formid) {
    currentpath += `/${formid}`;
  }
  const cInd = formPath.findIndex(p => p === currentpath);

  const getNextLink = () => {
    if (formPath.length > 0 && cInd > -1 && (cInd + 1) < formPath.length) {
      const newPath = formPath[(cInd + 1)];
      setGroup(newPath);
      return `/${mode}/${module}/edit/${namespace}/${id}/${newPath}`;
    }
    return false;
  }
  const onSubmitData = (next = false) => {
    clear();
    MainForm.validateFields().then(() => {
      const { _id, ...payloadData } = { ...editValues, form: subsection || group, module, view: viewGet[namespace] };
      setIsChanged(false);
      setNotificationMode(NOTIFICATION_MODE.EMPTY);
      setLoading(true);
      localStorage.setItem(`${id}-loading`, true);
      const callback = (type, m) => {
        localStorage.removeItem(`${id}-loading`);
        localStorage.setItem(`${id}-updated`, true);
        // setIsChanged(true);
        if (type === MessageTypes.SUCCESS) {
          message.success(m);
          if (!next) {
            goTo(getViewLink());
          }
        } else {
          message.error(m);
        }
        localStorage.removeItem(`${id}-updated`);
        setLoading(false);
      }
      Object.keys(payloadData).forEach(key => {
        if (typeof payloadData[key] === 'object' && payloadData[key] !== null && propHasValue(payloadData[key])) {
          if (Object.keys(payloadData[key]).includes('fileList')) {
            const file = (payloadData[key].fileList || [])
              .map(file => file.response ? file.response : file)
              .filter(file => file && file.status === 'done');
            payloadData[key] = !Array.isArray(file)
              ? file : file.filter((v, i, a) => a.indexOf(v) === i);
          } else {
            Object.keys(payloadData[key]).forEach(oKey => {
              if (typeof payloadData[key][oKey] === 'object' && payloadData[key][oKey] !== null && propHasValue(payloadData[key][oKey]) &&
                Object.keys(payloadData[key][oKey]).includes('fileList')) {
                const file = (payloadData[key][oKey].fileList || [])
                  .map(file => file.response ? file.response : file)
                  .filter(file => file && file.status === 'done');
                payloadData[key][oKey] = !Array.isArray(file)
                  ? file : file.filter((v, i, a) => a.indexOf(v) === i);
              }
            })
          }
        }
        if (Array.isArray(payloadData[key])) {
          // remove empty arrays
          payloadData[key] = payloadData[key].filter(f => typeof f !== 'object' || (Object.keys(f).length > 0 && Object.keys(f).filter(fk => propHasValue(f[fk])).length > 0));
        }
      });
      submitCall[namespace]((!editValues && !editValues.id)
        ? payloadData
        : Object.assign(payloadData, { id: data.id }), callback);
    }).catch(e => { });
  }

  useEffect(() => () => {
    clear();
  }, []);

  const namespaceAllPath = {
    stakeholder: 'stakeholders',
    scp: 'scp',
    'mine-operators': 'mine-operators',
    location: 'locations',
    scl: 'scl',
    village: 'village',
    event: 'events',
    incidents: 'incidents',
    'corrective-actions': 'corrective-actions',
    lir: 'lir',
    project: 'projects',
    kyc: '',
    sp: '',
    im: '',
    sci: '',
    bpe: '',
    gm: '',
  }

  const pageHeaderExtra = [];
  titleDetails.map((e, i) => pageHeaderExtra.push(
    <React.Fragment key={`t-${i}`}>{e}</React.Fragment>
  ));

  const isTemplate = () => {
    const temp = form.find(f => f.id === group)
    return temp && temp.template && temp.excludeFromEdit ? temp.template : false;
  }

  const canDeleteAction = {
    stakeholder: checkPermission({ permission: 'stakeholders.canDelete', permissions: user?.role?.permissions }),
    scp: checkPermission({ permission: 'stakeholders.SCA.canDelete', permissions: user?.role?.permissions }),
    // TO-DO add permissions
    'mine-operators': checkPermission({ permission: 'stakeholders.SCA.canDelete', permissions: user?.role?.permissions }),
    location: checkPermission({ permission: 'locations.canDelete', permissions: user?.role?.permissions }),
    scl: checkPermission({ permission: 'locations.mineSites.canDelete', permissions: user?.role?.permissions }),
    project: checkPermission({ permission: 'projects.canDelete', permissions: user?.role?.permissions }),
    event: checkPermission({ permission: 'events.canDelete', permissions: user?.role?.permissions }),
    'corrective-actions': checkPermission({ permission: 'events.correctiveActions.canDelete', permissions: user?.role?.permissions }),
    incidents: checkPermission({ permission: 'events.incidents.canDelete', permissions: user?.role?.permissions }),
    document: checkPermission({ permission: 'documents.canDelete', permissions: user?.role?.permissions }),
    lir: checkPermission({ permission: 'stakeholders.LIR.canDelete', permissions: user?.role?.permissions }),
    village: checkPermission({ permission: 'locations.villages.canDelete', permissions: user?.role?.permissions }),
  };

  const namespaceRemove = {
    stakeholder: stakeholderRemove,
    scp: stakeholderRemove,
    'mine-operators': stakeholderRemove,
    location: sclRemove,
    scl: sclRemove,
    village: sclRemove,
    event: eventsRemove,
    incidents: eventsRemove,
    'corrective-actions': eventsRemove,
    lir: lirRemove,
    project: ProjectRemove,
  };

  const headerTags = useMemo(() => {
    return [{ label: data.datastakeId }];
  }, [data]);

  const extraPageActions =
    (typeof namespaceRemove[namespace] === 'function' && mode !== 'proxy' && canDeleteAction[namespace]) ? [
      {
        label: t('Delete'),
        onClick: () => setDeletionVisible(true),
      },
    ] : []

  const pageActions = [
    {
      label: t('Save'),
      onClick: () => onSubmitData(true),
      disabled: !isChanged,
      type: 'primary',
    },
    {
      label: t('Back'),
      onClick: () => {
        if (notificationMode === NOTIFICATION_MODE.PROJECT_SOURCES) {
          changeNotificationState({ onYes: () => goTo(getViewLink()) });
        } else {
          goTo(getViewLink())
        }
      },
    }
  ];

  const getTitle = () => {
    if (namespace === 'kyc' || namespace === 'scp' || namespace === 'mine-operators') {
      return data.name
    }
    return i18next.t('Edit Details');
  }

  useEffect(() => {
    if (isChanged) {
      setNotificationMode(NOTIFICATION_MODE.PROJECT_SOURCES);
      window.addEventListener('beforeunload', onBeforeUnload);
    } else {
      setNotificationMode(NOTIFICATION_MODE.EMPTY);
      window.removeEventListener('beforeunload', onBeforeUnload);
    }
  }, [isChanged]);

  const isAnalysis = useMemo(() => {
    const showKyc = namespace === 'kyc' ? module === 'cadd' : true;
    return analysisNamespaces.includes(namespace) && showKyc
  }, [namespace]);

  const breadCrumbs = useMemo(() => {
    return renderBreadCrumbs({
      view: namespace,
      t,
      isAnalysis,
      goTo,
      isView: true,
      mod: module,
      id: data.datastakeId,
    })
  }, [namespace, t, goTo, sourceId, data, isAnalysis])

  if (!data.id) {
    return <Loading />;
  }

  return (isSupported && canEditAction[namespace]() && selectedProject === PROJECTS.myData ? <Style>
    {isTemplate() ? <Template
      namespace={namespace}
      template={isTemplate()}
      conf={{
        form: form.find(f => f.id === group),
        data: data,
        group,
        match,
        linkingForms,
        module,
        formConfig,
        pageHeaderExtra,
        getViewLink,
        actions,
        language,
        submitCall,
        namespace,
        viewGet,
        id
      }}
      user={user}
    /> :
      <React.Fragment>
        <Modal
          title={(
            <ModalHeader
              title={t('Delete subject')}
            />
          )}
          open={deletionVisible}
          onCancel={() => setDeletionVisible(false)}
          onOk={() => {
            setLoading(true);
            namespaceRemove[namespace]({ id: data.id, data: { parentId: data.parent || null, reason: deletionReason } }, (type, m) => {
              displayMessage(type, m);
              setDeletionVisible(false);
              setDeletionReason(null);
              goTo(`/${mode}/${module}/${namespaceAllPath[namespace]}`);
              setLoading(false);
            });
          }}>
          <Select
            {...getPopupContainer()}
            onChange={ev => setDeletionReason(ev)}
            placeholder={t('Please indicate the reason for deleting this subject')}
            style={{ width: '100%' }}>
            <Select.Option value="Duplicate">
              {t('Duplicate. This subject is already identified')}
            </Select.Option>
            <Select.Option value="Error">
              {t('Issue with core data')}
            </Select.Option>
            <Select.Option value="Non-Existent">
              {t('Subject does not exist and was created by mistake')}
            </Select.Option>
            <Select.Option value="Other">
              {t('Other reason')}
            </Select.Option>
          </Select>
        </Modal>
        <Header
          breadcrumbs={breadCrumbs}
          title={getTitle()}
          actionButtons={pageActions}
          extraButtons={extraPageActions}
          tags={headerTags}
        />
        <div className="view-content">
          <Sections
            mod={module}
            formConf={form}
            values={data}
            onChangeForm={(sForm) => {
              setSelectedForm(sForm);
            }}
            match={match}
            group={group}
            subsection={subsection}
            subgroup={subgroup}
            formid={formid}
            user={user}
          />
          <EditForm
            MainForm={MainForm}
            onValuesChange={(val, all) => {
              setEditValues(all);
              const keys = val && typeof val === 'object' ? Object.keys(val) : [];
              if (keys.length === 1) {
                const changedKey = keys[0];
                const ogData = originalData[changedKey];
                const newData = all[changedKey];
                let changePath = JSON.parse(JSON.stringify(changedPath));
                if (!hasNotChanged({ [changedKey]: ogData }, { [changedKey]: newData })) {
                  if (!changePath.includes(changedKey)) {
                    changePath.push(changedKey);
                  }
                } else {
                  changePath = changePath.filter(k => k !== changedKey);
                }
                setChangedPath([
                  ...changePath
                ]);
                setIsChanged(changePath.length > 0 ? true : false);
              } else {
                setIsChanged(true);
              }
              prepareForm(false)
            }}
            disabledInputs={formConfig.disabledInputs || []}
            excludedKeys={[]}
            hasSections={hasSubSections}
            linkingForms={linkingForms}
            form={selectedForm}
            data={data}
          />
        </div>

        {loading && <Loading background="white" />}
      </React.Fragment>
    }
  </Style> : <NotFound />);
}

const mstp = ({
  stakeholder,
  scl,
  authentication,
  events,
  documents,
  lir,
  project,
  sp,
  im,
  sci,
  bpe,
  gm,
}) => ({
  stakeholder,
  scl,
  authentication,
  events,
  documents,
  lir,
  project,
  sp,
  im,
  sci,
  bpe,
  gm,
});

const EditComponent = connect(mstp, actions)(Edit);

export default function Base() {
  const { namespace } = useParams();

  if (['amp', 'mine-profile', 'ownership-kyc', 'application-form', 'programs', 'esg-assessment'].includes(namespace)) {
    return <EditTIF />
  }

  return <EditComponent />
};
